<template>
	<a :href="path" class="news-link f-cb">
		<div class="col-l bg-d f-fl" v-if="showImg">
			<div class="bg-c" :style="{backgroundImage:'url('+ showImg+')'}"></div>
			<i :class="['icon', 'icon-' + item.type]"></i>
		</div>
		<div class="col-m">
			<div class="title f-toe2">{{item.listTitle || item.title}}</div>
			<div class="info-l">
				<span class="time" v-if="item.date">{{item.date | dataISO}}</span>
				<span class="join-count" v-if="showJoin">参与&nbsp;{{item.join_count}}</span>
				&nbsp;
			</div>
			<div class="info-r">
				<span class="tag" v-if="showTag">{{item.tags}}</span>
				<span class="comment-count" v-if="item.comments!='0'&& item.comments">{{item.comments}}</span>
				&nbsp;
			</div>
		</div>
	</a>
</template>

<script>
import imgMixin from 'mixins/image'
import newsItemMixin from 'mixins/news-item'
export default {
	mixins: [imgMixin, newsItemMixin],
	props: ['item'],
	computed: {
		// showpicture(){
		// 	if(this.item.isTailor){
		// 		return this.item.images[0]
		// 	}else{
		// 		return this.item.realImages[0]
		// 	}
		// },
		showImg() {
			//console.log(new Date(this.item.date))
			if(this.item.isTailor){
				return this.item.images?this.item.images[0]:""
			}else{
				return this.item.realImages?this.item.realImages[0]:""
			}
			//console.log(this.item)
			// const images = this.item.images||this.item.realImages;
			// if(!Jt.array.isEmpty(images)) {
			// 	return true;
			// }
			// return false;
		},
		showJoin() {
			const joinCount = parseInt(this.item.joinCount);
			if(joinCount === 0 || isNaN(joinCount)) {
				return false;
			}
			return true;
		},
		showTag() {
			const tag = this.item.tags;
			if(!Jt.string.isEmpty(tag)) {
				return true;
			}
			return false;
		},
		showComment() {
			const count = this.item.comments;		
			if(!Jt.string.isEmpty(count) && count !== '0') {
				return true;
			}
			return false;
		}
	}
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	@import "~src/styles/base.styl";
	@import '~src/styles/page-topic.styl';
	@import '~src/styles/news-stream.styl';
</style>


// WEBPACK FOOTER //
// news-normal.vue?d061a34a